// Free Marketing Health Check page content (also used by the prerender script).
const SITE = 'https://yellowagency.co.uk';

export const CONSULTATION = {
  slug: 'free-marketing-health-check',
  label: 'Free Marketing Health Check',
  month: 'November',
  deadlineLabel: '30th October',
  usualPrice: '£750',
  metaTitle: 'Free Marketing Health Check with Yellow\u2019s Directors | Liverpool Marketing Agency',
  metaDescription: 'Apply for a free 2 hour Marketing Health Check with the directors of Yellow, a Liverpool marketing agency. Usually £750, free for 15 businesses, public sector organisations, charities and universities in November. Applications close 30th October.',
  headline: 'Could your marketing achieve better results? Find out for free.',
  yellow: 'Find out for free.',
  intro: [
    'We are now taking applications for a Free Marketing Health Check in November. Spend up to 2 hours on a video call with Yellow\u2019s directors, who will check the health of your current marketing and tell you exactly what to change.'
  ],
  included: [
    { title: 'A full check of your current marketing', body: 'We go through your website, social media, content, adverts and campaigns, and tell you honestly what is working and what is not.' },
    { title: 'Save time and money', body: 'We show you where your time and budget are being wasted, and simpler, cheaper ways to get better results.' },
    { title: 'What you are missing', body: 'We explain the types of marketing you are not doing yet but need to, and how to start them.' },
    { title: 'Advice built around you', body: 'All advice is bespoke. Nothing generic, no templates, just recommendations for your organisation, your audiences and your budget.' },
    { title: 'A questionnaire before we meet', body: 'You complete a short questionnaire first, so we have done our homework and can get straight into useful advice.' },
    { title: 'Up to 2 hours with our directors', body: 'An online video call with experienced directors who have delivered over 1,000 projects since 2010.' }
  ],
  steps: [
    { title: 'Apply by 30th October', body: 'Fill in the short form below. Only 15 spaces are available for November.' },
    { title: 'Complete the questionnaire', body: 'If you are offered a space, we send a short questionnaire about your organisation and its marketing.' },
    { title: 'Meet our directors online', body: 'A video call of up to 2 hours in November, at a time that suits you.' },
    { title: 'Leave with a clear plan', body: 'You walk away knowing what to stop, what to fix and what to start doing next.' }
  ],
  promise: {
    title: 'No selling. No pitching. Just advice.',
    body: 'This is not a sales call in disguise. Your health check is purely to give you advice you can act on yourself, whether or not you ever work with us.',
    review: 'All we ask is that afterwards, if you found the advice useful, you leave us a Google review for your health check. You are under no obligation to.'
  },
  faqs: [
    { q: 'Is the Marketing Health Check really free?', a: 'Yes. A Marketing Health Check is usually £750, but in November 15 organisations can have one completely free. There is no catch and no obligation to buy anything afterwards.' },
    { q: 'When is the deadline to apply?', a: 'Applications close on 30th October, or sooner if all 15 spaces are taken. We recommend applying as early as possible.' },
    { q: 'How long is the health check and where does it take place?', a: 'Each Marketing Health Check is an online video call lasting up to 2 hours, held in November at a time that suits you.' },
    { q: 'Will you try to sell me your services?', a: 'No. There is no selling or pitching. The session is purely to give you bespoke marketing advice you can use yourself.' },
    { q: 'What does the Marketing Health Check cover?', a: 'We review your current marketing, show you how to save time and money on what you are already doing, and explain the types of marketing you are missing and need to start.' },
    { q: 'Do I need to prepare anything?', a: 'Just the short questionnaire we send before the meeting. It means we can get straight into useful advice rather than spending the session on background questions.' },
    { q: 'What types of organisations is the Marketing Health Check suitable for?', a: 'It is suitable for established organisations that already invest in marketing or communications, including SMEs, public sector organisations, charities, educational establishments such as universities, colleges and schools, healthcare providers and retailers. It is not designed for start ups or very small businesses, because the session covers marketing budgets, resources and how to get more from your existing spend.' },
    { q: 'Who will I be speaking to?', a: 'You will meet David Roberts, Yellow\u2019s Head of Strategy. David has managed over 100 projects and has worked across every one of these sectors, including SMEs, the public sector, charities, education, healthcare and retail, so he understands the challenges organisations like yours face.' }
  ]
};

export const consultationSchema = () => {
  const c = CONSULTATION;
  const url = `${SITE}/${c.slug}`;
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Service',
        '@id': `${url}#service`,
        name: 'Free Marketing Health Check',
        serviceType: 'Marketing audit and consultancy',
        url,
        description: c.metaDescription,
        provider: { '@id': `${SITE}/#organization` },
        areaServed: { '@type': 'Country', name: 'United Kingdom' },
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'GBP',
          availability: 'https://schema.org/LimitedAvailability',
          validThrough: '2026-10-30T23:59:59+00:00',
          eligibleQuantity: { '@type': 'QuantitativeValue', value: 15 },
          url
        }
      },
      {
        '@type': 'FAQPage',
        mainEntity: c.faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } }))
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE}/` },
          { '@type': 'ListItem', position: 2, name: 'Free Marketing Health Check', item: url }
        ]
      }
    ]
  };
};
